import React from 'react';
import Modal from 'react-bootstrap/Modal'
import {useDispatch, useSelector} from "react-redux";
import {deleteExpenseTemplate, setDeleteExpenseTemplateId} from "../../actions/expense_template";

const ExpenseTemplateDeleteForm = () => {

    const dispatch = useDispatch();

    const {delete_expense_template} = useSelector(state => state.expense_template);

    const closeModal = () =>{
        dispatch(setDeleteExpenseTemplateId(null))
    };


    const onConfirm = () =>{
        dispatch(deleteExpenseTemplate(delete_expense_template.id))
    };

    let condition = false;
    if(delete_expense_template !== null)
        condition = true;

    return (
        <div>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header className="bg-danger" closeButton>
                    <Modal.Title className="text-white" >Harajat shablonini o'chirish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Siz haqiqatdan ham ushbu harajat shablonini o'chirmoqchimisiz ?
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={closeModal} className="btn btn-secondary">YO'Q</button>
                    <button onClick={onConfirm} className="btn btn-primary">HA</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ExpenseTemplateDeleteForm;